<!--
/*******************************************************************************
*@ 컴포넌트명   : MnrcvAcno.vue
*@ 컴포넌트설명 : 이체-입금계좌 전용 컴포넌트
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 직접입력(타행이체) -->
    <template v-if="obaobDstcd=='2'">
      <auc-manage-payees ref="payees" usePage="autoTransfer" :cncycd="baseCncycd" />
    </template>
    <!-- 직접입력(당행이체) -->
    <template v-else>
      <input-text
        ref="mnrcvAcno"
        id="mnrcvAcno"
        :value.sync="acnoChange"
        labelI18n="MPAY-02-01-25-09"
        required
        :engCase2="`${$config.SITECODE_OGHCM}`"
        :alphaNum="`${$config.SITECODE_OGMMR}|${$config.SITECODE_OGCBD}|${$config.SITECODE_OGAUC}`"
      />
    </template>
    <!-- 자주쓰는/최근이체/내계좌 버튼 -->
    <div class="inline-button-group">
      <button class="btn sm inline" @click="oftenAcno">{{ /*자주 쓰는*/ $t("MPAY-01-01-03-05") }}</button>
      <button class="btn sm inline" @click="latestAcno">{{ /*최근 이체*/ $t("MPAY-01-01-03-06") }}</button>
      <button
        class="btn sm inline"
        v-if="obaobDstcd!='2'"
        @click="myAcno"
      >{{ /*내 계좌*/ $t("MPAY-01-01-03-07") }}</button>
    </div>

    <!-- 자주쓰는 계좌 -->
    <action-sheet
      :opened.sync="oftenAcnoOpened"
      :action-footer="oftenAcnoList.length == 0"
      :no-negative-button="false"
      confirm="MMENU-0046"
      @confirm="$router.push({name:'managePayeesList'})"
      title="MPAY-01-01-03-05"
      :class="['action-sheet',oftenAcnoList.length > 0?'action-sheet--list-type':'' ]"
      @cancel="() => { this.$emit('click') }"
    >
      <template #content>
        <template v-if="oftenAcnoList.length > 0">
          <ul>
            <li v-for="(op, i) in oftenAcnoList" :key="i" @click="optionClick(op, i)">
              <mnrcv-template :data="op.data" />
            </li>
          </ul>
        </template>
        <template v-else>
          <div class="notice normal">
            <div class="notice-tit">
              <p>{{/*자주 쓰는 계좌가 없습니다.*/$t("MCOM-0000080")}}</p>
            </div>
            <div class="notice-cont">
              <p>{{/*주로 사용하는 입금 계좌를 자주 쓰는 계좌로 등록하시면 이체 업무를 빠르고 편리하게 사용하실 수 있습니다.*/$t("MCOM-0000081")}}</p>
            </div>
          </div>
        </template>
      </template>
    </action-sheet>

    <!-- 최근이체 내역 -->
    <action-sheet
      :opened.sync="latestAcnoOpened"
      :action-footer="latestAcnoList.length == 0"
      :no-negative-button="false"
      confirm="MCOM-0000003"
      title="MPAY-01-01-03-06"
      :class="['action-sheet',latestAcnoList.length > 0?'action-sheet--list-type':'' ]"
      @cancel="() => { this.$emit('click') }"
    >
      <template #content>
        <template v-if="latestAcnoList.length > 0">
          <ul>
            <li v-for="(op, i) in latestAcnoList" :key="i" @click="optionClick(op, i)">
              <mnrcv-template :data="op.data" mnrcv="latest" />
            </li>
          </ul>
        </template>
        <template v-else>
          <strong class="info-question nomargin-top">{{/*최근 이체 계좌가 없습니다.*/$t("MCOM-0000082")}}</strong>
        </template>
      </template>
    </action-sheet>

    <!-- 내계좌 -->
    <action-sheet
      :opened.sync="myAcnoOpened"
      :action-footer="myAcnoList.length == 0"
      :no-negative-button="false"
      confirm="MCOM-0000003"
      title="MPAY-01-01-03-07"
      :class="['action-sheet',myAcnoList.length > 0?'action-sheet--list-type latest':'' ]"
      @cancel="() => { this.$emit('click') }"
    >
      <template #content>
        <template v-if="myAcnoList.length > 0">
          <ul>
            <li v-for="(op, i) in myAcnoList" :key="i" @click="optionClick(op, i)">
              <mnrcv-template :data="op.data" />
            </li>
          </ul>
        </template>
        <template v-else>
          <div class="notice normal">
            <div class="notice-tit">
              <p>{{/*선택 가능한 계좌가 없습니다.*/$t("MCOM-0000083")}}</p>
            </div>
            <div class="notice-cont">
              <p>{{/*다음과 같은 이유로 계좌가 표시되지 않습니다.*/$t("MCOM-0000071")}}</p>
              <ol class="olist olist-number-type info-guide">
                <li>
                  <span class="num">①</span>
                  {{/*출금 계좌 이외에 내 계좌가 없는 경우*/$t("MCOM-0000072")}}
                </li>
                <li>
                  <span class="num">②</span>
                  {{/*거래 가능한 통화를 가진 계좌가 없는 경우*/$t("MCOM-0000073")}}
                </li>
                <!-- <li>
                  <span class="num">③</span>기업 사용자의 경우 계좌 권한이 없는
                  경우
                </li>-->
              </ol>
            </div>
          </div>
        </template>
      </template>
    </action-sheet>
    <error-modal ref="errorModal" />
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import MnrcvTemplate from "@/components/template/Mnrcv";
import { commonProps, valueProps, selectBoxProps } from "@/mixins/basicComponent";
import AucManagePayees from "@/components/page/customer/aucManagePayees";
import { RBF0400A40, RBF0405G40, RBF0404J40 } from "@/mixins/transfer";
import { RBF0404F40 } from "@/mixins/wholAcnInq";
import ErrorModal from "@/components/modal/ErrorModal";

export default {
  name: "MnrcvAcno",
  mixins: [commonProps, valueProps, selectBoxProps, RBF0400A40, RBF0404F40, RBF0405G40, RBF0404J40],
  components: { MnrcvTemplate, AucManagePayees, ErrorModal },
  props: {
    // 당행/타행 구분 (1:당행, 2:타행)
    obaobDstcd: {
      type: String,
      default: "1",
    },
    drwotCncycd: String,
    page: String,
    onlyBaseCncycd: {
      type: Boolean,
      default: false,
    },
    baseCncycd: String,
  },
  data() {
    return {
      oftenAcnoOpened: false,
      latestAcnoOpened: false,
      myAcnoOpened: false,
      oftenAcnoList: [], //자주쓰는
      latestAcnoList: [], //최근이체
      myAcnoList: [], //내계좌
      mnrcvInqInfo: "",
      acno: "",
      selectedText: "",
      selectedValue: "",
      selectedIndex: -1,
      selectedData: "",
    };
  },
  computed: {
    ...mapFields("transfer/autoTrsaccInfoInpt", ["mnrcvAcno"]),
    acnoChange: {
      get() {
        return this.acno;
      },
      set(value) {
        if (value != this.getAcnoInfo().acno) {
          this.optionClick(-1);
        }
        this.acno = value;
        this.$refs.mnrcvAcno.$v.$touch();
      },
    },
  },
  methods: {
    acnoInit() {
      this.$refs.mnrcvAcno.initInputText();
    },
    /**
     * 계좌번호 selectbox 선택
     */
    optionClick(option, i) {
      this.selectedText = typeof option == "number" ? (!this.hiddenDefaultText ? this.defaultText : "") : option.text;
      this.selectedValue = typeof option == "number" ? "" : option.value;
      this.selectedIndex = typeof option == "number" ? -1 : i;
      this.selectedData = typeof option == "number" ? "" : option.data;

      // this.$forceUpdate();
      if (this.selectedIndex != -1) {
        if (this.obaobDstcd == "2") {
          this.$refs.payees.setText(option.data);
        } else {
          this.$refs.mnrcvAcno.setText(option.value.split(";")[0]);
        }
      }
      this.oftenAcnoOpened = false;
      this.latestAcnoOpened = false;
      this.myAcnoOpened = false;

      this.$emit("update:value", this.selectedValue);
      this.$emit("selected", this.selectedData);
    },
    /**
     * 자주쓰는계좌 open
     */
    async oftenAcno() {
      const res = await this.RBF0400A40CallMnrcv();
      if (res.length > 0) {
        this.oftenAcnoList = res;
      }
      this.$emit("click");
      this.oftenAcnoOpened = true;
    },
    /**
     * 최근이체 내역 open
     */
    async latestAcno() {
      const res = await this.RBF0405G40Call();
      if (res.totalLineCnt > 0) {
        this.$set(this, "latestAcnoList", this.makeListMnrcv(res.data1, "RBF0405G40"));
      }
      this.$emit("click");
      this.latestAcnoOpened = true;
    },
    /**
     * 내계좌 open
     */
    myAcno() {
      //this.filterList -> wholAcnInq.js
      this.$set(this, "myAcnoList", this.makeListMnrcv(this.filterList, "RBF0404F40"));
      this.$emit("click");
      this.myAcnoOpened = true;
    },
    /**
     * 내계좌 목록 셋팅되면 호출되어 myAcnoList에 셋팅함
     * (filterList를 사용하지 않은 이유는 출금계좌번호 통화코드에 따라 또 filter 되어야해서)
     */
    acnoInitValue() {
      //this.filterList -> wholAcnInq.js
      this.myAcnoList = this.filterList;
    },
    /**
     * 선택 또는 입력한 계좌정보
     * @return {acno:"", cncycd:"", alias:""}
     */
    getAcnoInfo() {
      let data = !_.isEmpty(this.selectedValue) && !_.isNil(this.selectedValue) ? this.selectedValue.split(";") : [];

      if (data.length > 0) {
        return {
          acno: data[0],
          cncycd: data.length > 1 ? data[1] : "",
          alias: data.length > 2 ? data[2] : "",
        };
      } else {
        return {
          acno: "",
          cncycd: "",
          alias: "",
        };
      }
    },

    /**
     * 선택 또는 입력한 계좌정보 (async)
     * @return {acno:"", cncycd:"", alias:""}
     */
    async getAcnoInfoAsync() {
      let data = !_.isNil(this.selectedValue) && !_.isEmpty(this.selectedValue) ? this.selectedValue.split(";") : [];

      if (data.length > 0) {
        return {
          acno: data[0],
          cncycd: data.length > 1 ? data[1] : "",
          alias: data.length > 2 ? data[2] : "",
        };
      } else {
        //사용자 입력계좌 조회
        if (!_.isEmpty(this.acno)) {
          const res = await this.RBF0404J40Call(this.acno);

          if (res) {
            if ((await this.makeListMnrcv([res]).length) < 1) {
              res.acno = "";
              res.cncycd = "";
              res.alias = "";
            }

            return {
              acno: res.acno,
              cncycd: res.cncycd, // check cncy
              alias: "",
            };
          }
        }

        return {
          acno: "",
          cncycd: "",
          alias: "",
        };
      }
    },
    /**
     * set text
     * @param {String} str set text
     */
    setText(str, value) {
      this.$refs.mnrcvAcno.setText(str);
      this.selectedValue = value;
    },
  },
};
</script>